<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner9.png" alt="">
        <div class="main">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li>新闻资讯</li>
            </ul>
            <h3 class="tab_title">新闻资讯</h3>
        </div>
        <div class="main news">
            <div @click="goPath(item)" class="subNew" v-for="(item, index) in newsList" :key="index">
                <div class="img_w">
                    <img :src="item.coverImage" alt="">
                    <!-- <img :src="item.coverImage" alt=""> -->
                </div>
                <div class="newsContent">
                    <p>{{ item.title }}</p>
                    <span v-if="item.description">{{ item.description.slice(0,40) }}<font v-if="item.description.length>40">...</font></span>
                </div>
            </div>
        </div>
        <pagination style="margin-top:10px" :num="total" :limit="9" @getNew="getList"></pagination>
    </div>
</template>
<script>

import { getNewsList } from '../../api/index'
import pagination from "../../components/page/pagination.vue"
export default {
    data() {
        return {
            newsList: [],
            total: 0
        }
    },
    components: {
        pagination
    },
    methods: {
        backPage(page){
            if(page == '-1'){
                this.$router.go(-1)
            }else{
                this.$router.push(page)
            }
        },
        getList(val) {
            let params = {
                pageNum: val + 1,
                pageSize: 9,
                publishStatus:1,
                category:1
            }
            getNewsList(params).then(res => {
                this.newsList = res.rows
                this.total = res.total
            })
        },
        goPath(item) {
            console.log(item);
            this.$router.push({ path: '/newsDetail', query: { id: item.id } })
            document.documentElement.scrollTop = 0;

        }
    },
    mounted() {
        this.getList(0)
    }
} 
</script>
<style lang="scss" scoped>
.news {
    overflow: hidden;

    .subNew {
        width: 380px;
        float: left;
        box-sizing: border-box;
        height: 346px;
        margin: 10px 0;
        margin-right: 28px;
        cursor: pointer;

        .img_w {
            height: 240px;
            overflow: hidden;
            // img{
            //     width: 100%;
            // }
        }

        img {
            width: 100%;
            transform: scale(1, 1);
            transition: all 0.2s linear;
        }

        img:hover {
            transform: scale(1.2, 1.2);
            transition: all 0.2s linear;
        }
    }

    .subNew:hover {
        box-shadow: 1px 5px 6px #999;
        // padding-bottom: 10px;
        p{
            color: #226189;
        }
    }

    .subNew:nth-child(3n+3) {
        margin-right: 0;
    }
}

.newsContent {
    background: #fff;
    height: 110px;
    padding: 10px 24px;
    box-sizing: border-box;

    p {
        font-size: 18px;
        // line-height: 40px;
        font-family: 'MicrosoftYaHei';
        overflow: hidden; //超出文本隐藏
        text-overflow: ellipsis; ///超出部分省略号显示
        display: -webkit-box; //弹性盒模型
        -webkit-box-orient: vertical; //上下垂直
        -webkit-line-clamp: 1;
        margin-bottom: 10px;
        padding-top: 4px;
    }

    span {
        display: block;
        overflow: hidden; //超出文本隐藏
        text-overflow: ellipsis; ///超出部分省略号显示
        display: -webkit-box; //弹性盒模型
        -webkit-box-orient: vertical; //上下垂直
        -webkit-line-clamp: 2;
        // padding: 0 16px;
        font-size: 14px;
        line-height: 22px;
        font-family: 'MicrosoftYaHeiLight';
    }
}
</style>


// WEBPACK FOOTER //
// src/views/news/index.vue